module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/andrews-page/andrews-page.component.css
// module id = ./src/app/andrews-page/andrews-page.component.css
// module chunks = main